import { FC } from 'react';
import { usePageNavigation } from '../hooks/usePageNavigation';

export const NavigationListener: FC = () => {
  usePageNavigation();

  return null;
};
